export enum UserRole {
  SUPER_ADMIN = 'SuperAdmin',
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  SPECTATOR = 'Spectator'
}

export type UserType = {
  id: string;
  firstName: string;
  infix: string | null;
  lastName: string;
  username: string;
  email: string;
  roleName: string;
  lastLogin: string;
  role: UserRole;
  isDeleted?: boolean;
  isInvitationPending: boolean;
};
